import React, { useState } from 'react';
import Mobiscroll from '../Vendor/Mobiscroll/mobiscroll.custom-4.7.3.min.js';
import { SelectClearButton } from "./SelectClearButton";
import { Mask } from "./Mask";
import "./style/SliderMobiscroll/styles.scss";
import _ from "lodash";

export const SliderMobiscroll = (props) => {
    const [enabled, setEnabled] = useState(false);

    const getLabels = () => {
        var labels = [],
            labelsString = '';

        for(var i = props.min; i <= props.max; i+= props.step){
            labels.push(i.toString());
        }

        labelsString = '['+labels.join(',')+']';
        return labelsString;
    }
    
    const handleDateRangeChange = event => {
        setEnabled(event.detail.enabled);
    }

    const onChange = (value) => {
        props.onChange(value);
    }

    var labels = getLabels();

    return (
        <div className="pricerange-slider search-field-container pb-4 bg-white border-radius-default">
            <Mobiscroll.Slider
                value={props.value ? props.value : [props.min, props.max]}
                onChange={(value) => onChange(value)}
                min={props.min}
                max={props.max}
                step={props.step}
                data-tooltip="false"
                data-step-labels={labels}
                >
                <div className="inline-block width-100">
                    <div className="flex items-center">
                        {props.label}
                        <SelectClearButton
                        onChange={(value) => props.onChange(null)}
                        clearable={props.clearable}
                        value={props.value && _.isEqual(props.value, [props.min, props.max]) === false ? props.value : null}
                        relative={true}
                        className="py-1 px-2 ml-2 bor-no btn font-120 bg-grey3 blue1"
                        />
                    </div>
                </div>
            </Mobiscroll.Slider>
            {props.disabled && <Mask />}
        </div>
    );
}